import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { CompanyGroup } from '../../../../company-group/state/company-group.model';
import { SubscriptionService } from '../../../../setting/services/subscription.service';
import { ParentOfComponent } from '../../../../ui/parent-component/components/parent-of.component';
import { User } from '../../../../user/models/User';
import { Employee } from '../../../models/Employee';

@Component({
    selector: 'app-change-entity-active-access-modal',
    templateUrl: './change-entity-active-access-modal.component.html',
    styleUrls: ['./change-entity-active-access-modal.component.css']
})

export class ChangeEntityActiveAccessModalComponent extends ParentOfComponent implements OnInit {
    public employee: Employee;
    public user: User;
    public form: UntypedFormGroup;
    public companyGroups$: Observable<CompanyGroup[]>;
    public translateEntity = 'employees';
    public emailTaken = false;

    private _inputTimeout: any;
    private _debounceTime = 500;

    constructor(
        public activeModal: NgbActiveModal,
        private _subscriptionService: SubscriptionService,
    ) {
        super();
    }

    public ngOnInit(): void {
        this.form = this.fb.group({
            activate: [false, Validators.required]
        });

        if (this.user) {
            this.translateEntity = 'users';
        }

        if (!this.employee?.has_active_access && !this.user?.is_active) {
            this.form.addControl('send_invite', this.fb.control(true));
            this.form.patchValue({activate: true});
            if (this.employee) {
                this.form.addControl('email', this.fb.control(this.employee.email, Validators.required));
            }
        }
    }

    public sendInvitation(): void {
        this._subscriptionService.sendInvite({
            email: this.employee ? this.employee.email : this.user.email,
            id: this.employee ? this.employee.user_ID : this.user.user_ID
        }).then(() => { },
            () => { });
    }

    public resetPassword(): void {
        if (this.employee) {
            void this.employeeService.resetEmployeePassword(this.employee.employee_ID);
        } else {
            void this.userService.resetUserPassword(this.user.user_ID);
        }
    }

    public onSubmit(): void {
        if (this.employee && !this.emailTaken) {
            const form = {...this.form.value};
            if (this.employee.email === this.form.value.email) {
                delete form.email;
            }
            this.employeeService.toggleEmployeeActiveAccess(this.employee.employee_ID, form)
                .then(() => {
                    this.activeModal.close();
                }, () => { });
        } else {
            this.userService.toggleActiveUser(this.user.user_ID, this.form.value)
                .then(() => {
                    this.activeModal.close();
                }, () => { });
        }
    }

    public inputChanged($event): void {
        clearTimeout(this._inputTimeout);
        this._inputTimeout = setTimeout(() => {
            if ($event.target.value !== '') {
                this.checkDuplicity($event.target.name, $event.target.value);
            }
        }, this._debounceTime);
    }

    public checkDuplicity(name, value): void {
        this.userService.checkPropertyExistence(name, value)
            .then((response: any) => {
                if (name === 'email') {
                    this.emailTaken = response.disable_continue && (typeof this.employee === undefined || this.employee?.user_ID !== response.user_ID);
                }
            })
            .catch(() => { });
    }
}
